import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const EmailTemplateBank = lazy(() => import("../pages/email/template-bank"));
const AllEmailTemplates = lazy(() => import("../pages/email/all-templates"));
const CreateEmailTemplate = lazy(() =>
  import("../pages/email/create-template")
);
const AllSmsTemplates = lazy(() => import("../pages/sms/all-templates"));
const SmsTemplateBank = lazy(() => import("../pages/sms/template-bank"));
const CreateSmsTemplate = lazy(() => import("../pages/sms/create-template"));
const CreateWhatsappTemplate = lazy(() =>
  import("../pages/whatsapp/create-template")
);
const WhatsappTemplateBank = lazy(() =>
  import("../pages/whatsapp/template-bank")
);
const AllWhatsappTemplates = lazy(() =>
  import("../pages/whatsapp/all-templates")
);
const CreateTelegramTemplate = lazy(() =>
  import("../pages/telegram/create-template")
);
const TelegramTemplateBank = lazy(() =>
  import("../pages/telegram/template-bank")
);
const AllTelegramTemplates = lazy(() =>
  import("../pages/telegram/all-templates")
);
const EmailTemplateDetails = lazy(() =>
  import("../pages/email/template-details")
);
const SmsTemplateDetails = lazy(() => import("../pages/sms/template-details"));
const WhatsappTemplateDetails = lazy(() =>
  import("../pages/whatsapp/template-details")
);
const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const AllVariables = lazy(() => import("../pages/variable/all-variable"));
const AllCategory = lazy(() => import("../pages/category/all-category"));
const AllBank = lazy(() => import("../pages/bank/all-bank"));
const CreateBank = lazy(() => import("../pages/bank/create-bank"));
const BankDetails = lazy(() => import("../pages/bank/bank-details"));
const Analytics = lazy(() => import("../pages/analytics"));

export const TemplateManagerRouter = [
  {
    path: "template-management",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "email-template",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllEmailTemplates />
          </Suspense>
        ),
        key: "email-teplate-list",
      },
      {
        path: "email-template/list",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllEmailTemplates />
          </Suspense>
        ),
        key: "email-teplate-list-alt",
      },
      {
        path: "email-template/bank",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmailTemplateBank />
          </Suspense>
        ),
        key: "email-teplate-bank",
      },
      {
        path: "email-template/create/",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateEmailTemplate />
          </Suspense>
        ),
        key: "email-teplate-create",
      },
      {
        path: "email-template/create/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateEmailTemplate />
          </Suspense>
        ),
        key: "email-teplate-create-by-id",
      },
      {
        path: "email-template/details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmailTemplateDetails />
          </Suspense>
        ),
        key: "email-teplate-details-by-id",
      },
      {
        path: "sms-template",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllSmsTemplates />
          </Suspense>
        ),
        key: "sms-teplate-list",
      },
      {
        path: "sms-template/list",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllSmsTemplates />
          </Suspense>
        ),
        key: "sms-teplate-list-alt",
      },
      {
        path: "sms-template/bank",
        element: (
          <Suspense fallback={<Backdrop />}>
            <SmsTemplateBank />
          </Suspense>
        ),
        key: "sms-teplate-bank",
      },
      {
        path: "sms-template/create/",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateSmsTemplate />
          </Suspense>
        ),
        key: "sms-teplate-create",
      },
      {
        path: "sms-template/create/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateSmsTemplate />
          </Suspense>
        ),
        key: "sms-teplate-create-by-id",
      },
      {
        path: "sms-template/details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <SmsTemplateDetails />
          </Suspense>
        ),
        key: "sms-teplate-details-by-id",
      },
      {
        path: "telegram-template",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllTelegramTemplates />
          </Suspense>
        ),
        key: "telegram-teplate-list",
      },
      {
        path: "telegram-template/bank",
        element: (
          <Suspense fallback={<Backdrop />}>
            <TelegramTemplateBank />
          </Suspense>
        ),
        key: "telegram-teplate-bank",
      },
      {
        path: "telegram-template/create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateTelegramTemplate />
          </Suspense>
        ),
        key: "telegram-teplate-create",
      },
      {
        path: "whatsapp-template",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllWhatsappTemplates />
          </Suspense>
        ),
        key: "whatsapp-teplate-list",
      },
      {
        path: "whatsapp-template/bank",
        element: (
          <Suspense fallback={<Backdrop />}>
            <WhatsappTemplateBank />
          </Suspense>
        ),
        key: "whatsapp-teplate-bank",
      },
      {
        path: "whatsapp-template/create/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateWhatsappTemplate />
          </Suspense>
        ),
        key: "whatsapp-teplate-create-by-id",
      },
      {
        path: "whatsapp-template/create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateWhatsappTemplate />
          </Suspense>
        ),
        key: "whatsapp-teplate-create",
      },
      {
        path: "whatsapp-template/details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <WhatsappTemplateDetails />
          </Suspense>
        ),
        key: "whatsapp-teplate-details-by-id",
      },
      {
        path: "variable",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllVariables />
          </Suspense>
        ),
      },
      {
        path: "category",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllCategory />
          </Suspense>
        ),
      },
      {
        path: "bank",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllBank />
          </Suspense>
        ),
      },
      {
        path: "create-bank",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateBank />
          </Suspense>
        ),
      },
      {
        path: "create-bank/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateBank />
          </Suspense>
        ),
      },
      {
        path: "bank/details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <BankDetails />
          </Suspense>
        ),
      },
      {
        path: "analytics",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Analytics />
          </Suspense>
        ),
      },
    ],
  },
];
